<!-- 修改密码 -->
<template>
  <el-dialog :title="$ts('修改密码')" top="20px" width="400px" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true" @close="hide" :before-close="beforeClose">
    <div class="dialog_scroll" v-loading="upLoading">
      <el-form @submit.native.prevent ref="form" :model="data" label-width="80px">
        <el-form-item :label="$ts('旧密码')" :rules="[{ min: 6, max: 16, message: $ts('长度在 6 到 16 个字符'), trigger: 'blur' }]">
          <el-input v-model="data.old_pwd" type="password" maxlength="16" :placeholder="$ts('长度在6-16之间')"></el-input>
        </el-form-item>
        <el-form-item :label="$ts('新密码')" :rules="[{ min: 6, max: 16, message: $ts('长度在 6 到 16 个字符'), trigger: 'blur' }]">
          <el-input v-model="data.new_pwd" type="password" auto-complete="old-password" maxlength="16" :placeholder="$ts('长度在6-16之间')"></el-input>
        </el-form-item>
        <el-form-item :label="$ts('确认密码')" :rules="[{ min: 6, max: 16, message: $ts('长度在 6 到 16 个字符'), trigger: 'blur' }]">
          <el-input v-model="data.re_new_pwd" type="password" auto-complete="new-password" maxlength="16" :placeholder="$ts('长度在6-16之间')"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog_footer">
      <el-button :loading="upLoading" @click="dialogVisible = false">{{$ts('取消')}}</el-button>
      <el-button type="primary" :loading="upLoading" @click="confirm">{{$ts('保存')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name:'',
    data() {
      return {
        dialogVisible: false,//弹框
        isConfirm: false,//是否点击确认 用于判定关闭窗口回调
        upLoading:false,//提交数据
        data: {
          old_pwd: '', //旧密码
          new_pwd: '',//新密码
          re_new_pwd: '',//确认密码
        },//传入数据
        updata: {},//回调数据
      }
    },
    methods: {
      /* 显示弹框 */
      show() {
        for(let key in this.data){
          this.data[key] = '';
        }
        this.isConfirm = false;
        this.dialogVisible = true;
        this.emitChange('show')
      },
      /* 隐藏弹框 */
      hide() {
        let type = this.isConfirm ? 'confirm' : 'hide';
        this.emitChange(type)
      },
      /* 隐藏弹框前回调 */
      beforeClose(done){
        if(!this.upLoading){
          done()
        }else{
          this.$message.error(this.$ts('正在提交数据，无法关闭'))
        }
      },
      /* 执行回调 */
      emitChange(type){
        this.$emit('change', {
          type: type,
          data:this.data,
          updata: (this.isConfirm ? this.updata : ''),
        })
      },
      /* 确认数据 */
      confirm() {
        if (!this.data.new_pwd || !this.data.re_new_pwd) {
          this.$message({
            type: 'waring',
            message: this.$ts('新密码不一致!')
          })
        }else{
          this.upLoading = true;
          this.request({
            url:'/admin/user/changePwd',
            data:{
              ...this.data
            },
            is_public:true,
            complete: (res) => {
              this.upLoading = false;
              if (res.error_code == 0) {
                this.$message.success(this.$ts('密码修改成功'))
                this.dialogVisible = false
              } else {
                this.$message.error(res.error_msg);
              }
            }
          })
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar/ModifyPassword.vue